import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "./scss/style.scss";
import "react-toastify/dist/ReactToastify.css";
import AdminRoute from "./components/AdminRoute";
import NotPrivateRoute from "./components/NotPrivateRoute";
import VoluntaryRoute from "./components/VoluntaryRoute";
import { Loading } from "./components/Loader";

import TheLayout from "containers/TheLayout";
import Login from "views/Login";
import Page404 from "views/Page404";
import Page500 from "views/Page500";
import Reservation from "views/Reservation";
import Inlet from "views/Inlet";
import Cancel from "views/Cancel";
import GetReservation from "views/GetReservation";
import NoBooking from "views/NoBooking";

class App extends Component {
  render() {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <BrowserRouter>
          <React.Suspense fallback={Loading}>
            <Switch>
              <NotPrivateRoute
                exact
                path="/login"
                name="Login Page"
                component={Login}
              />
              <Route
                exact
                path="/reservas"
                name="Reservas"
                render={(props) => <NoBooking {...props} />}
              />
              <Route
                exact
                path="/iglekids"
                name="Reservas"
                render={(props) => <Reservation category="IGLEKIDS" {...props} />}
              />
              <Route
                exact
                path="/eventos"
                name="Reservas"
                render={(props) => <Reservation category="ESP" {...props} />}
              />
              <Route
                exact
                path="/kids"
                name="Reservas"
                render={(props) => <Reservation category="KID" {...props} />}
              />
              <Route
                exact
                path="/young"
                name="Reservas"
                render={(props) => <Reservation category="YOUNG" {...props} />}
              />
              <Route
                exact
                path="/cancelar"
                name="Cancelar reserva"
                render={(props) => <Cancel {...props} />}
              />
              <Route
                exact
                path="/consultar"
                name="Consulta tu reserva"
                render={(props) => <GetReservation {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
              <VoluntaryRoute
                path="/registro"
                name="Registro"
                component={Inlet}
              />
              <AdminRoute
                path="/privado"
                name="Privado"
                category="PRV"
                component={Reservation}
              />
              <AdminRoute path="/" name="Inicio" component={TheLayout} />
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
